export const userRoles = {
  PetasenseAdmin: 'petasense_admin',
  PetasenseViewer: 'petasense_viewer',
  OrgAdmin: 'org_admin',
  Analyst: 'analyst',
  Admin: 'admin',
  Technician: 'technician',
  Manager: 'manager',
  PartnerAdmin: 'partner_admin'
};

export const operations = {
  Create: 'create',
  Read: 'read',
  Update: 'update',
  Delete: 'delete'
};

export const mapComponentToResource = {
  Accounts: 'accounts',
  AccountDashboard: 'account_dashboard',
  AccountUsers: 'users',
  Activity: 'activity',
  Areas: 'areas',
  BearingDetails: 'bearing_models',
  BhsItem: 'charts',
  ChartItem: 'charts',
  ChartMultilineItem: 'charts',
  ComponentDetails: 'components',
  EventDefinition: 'event_definition',
  MachineCharts: 'charts',
  MachineDetails: 'machines',
  Sensors: 'sensors',
  SiteProfile: 'accounts',
  TermsPage: 'accounts',
  Machines: 'machines',
  // Demo and site-to-site machine cloning. Granted to no customer role in
  // rbac_permission_rules.json, so checkPermissions only lets through the
  // Petasense admin / partner admin short-circuit.
  MachineClone: 'machine_clone',
  Organisations: 'organisations',
  HierarchyView: 'accounts',
  DiagnosticRules: 'diagnostic_rules',
  DiagnosticResults: 'diagnostic_results',
  Tags: 'tags',
  DiagnosticTestRun: 'diagnostic_rules_test_run',
  ThirdPartyIntegrations: 'third_party_integration',
  TagTemplates: 'tag_templates',
  TaskTemplates: 'task_templates',
  FirmwareDeployments: 'firmware_deployment',
  Attachments: 'attachments',
  Dashboard: 'dashboard',
  RUL: 'rul',
  Notes: 'notes',
  Tasks: 'tasks',
  Repairs: 'repairs',
  FeatureNormalization: 'feature_normalization',
  InstrumentationAlerts: 'instrumentation_alerts',
  VibrationAgent: 'vibration_agent',
  MachineHealthScore: 'machine_health_score',
  Fmea: 'fmea'
};
